/** 简单错误边界：子树抛错时显示提示而非白屏（如 SimulationPage 解析非法配置失败）。 */
import { Component, type ReactNode } from 'react';

interface Props {
  children: ReactNode;
}
interface State {
  error: string | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(e: unknown): State {
    return { error: e instanceof Error ? e.message : String(e) };
  }

  render(): ReactNode {
    if (this.state.error) {
      return (
        <div className="max-w-2xl mx-auto p-8 space-y-3">
          <h2 className="text-lg font-bold text-red-400">页面出错</h2>
          <pre className="text-sm text-slate-300 bg-slate-900/60 border border-slate-800 rounded-md p-3 whitespace-pre-wrap">
            {this.state.error}
          </pre>
          <p className="text-sm text-slate-400">通常是当前配置非法或状态不一致。返回配置页调整后再试。</p>
          <button
            onClick={() => {
              this.setState({ error: null });
              window.location.hash = '#/config';
            }}
            className="px-4 py-2 rounded-md bg-blue-600 hover:bg-blue-500 text-white text-sm"
          >
            返回配置
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
